import callApi from './eventActivtiyService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/activity-reserve`;

export const getEventActivity = (id) => callApi({
    method: 'GET',
    endpoint: `${basePath}/activity/${id}`
  });
export const getStoreTimeList = (id) => callApi({
    method: 'GET',
    endpoint: `${basePath}/period/${id}`
  });
export const getEventActivityList = (query) => callApi({
    method: 'GET',
    endpoint: `${basePath}/member?${query}`
  });
export const getEventActivityEditData = (id) => callApi({
    method: 'GET',
    endpoint: `${basePath}/member/${id}`
  });
export const sendEventActivity = (data) => callApi({
    method: 'POST',
    endpoint: `${basePath}/member`,
    body: data
});
export const cancelEventActivity = (id) => callApi({
  method: 'PATCH',
  endpoint: `${basePath}/status/${id}/cancel`
});
export const updateEventActivity = (formData) => callApi({
  method: 'PUT',
  endpoint: `${basePath}/member/${formData.id}`,
  body: formData
});
